var EXIF = require('exif-js');

export default {
  methods: {
    getFixedImage(file, rawImage, length, index, afterAction) {
      return new Promise((resolve, reject) => {
        EXIF.getData(file, () => {
          let params = {
            file: file,
            rawImage: rawImage,
            length: length,
            index: index
          };
          resolve(params);
        });
      })
      .then((params) => {
        return this.exifFile(params.file, params.rawImage, params.length, params.index, afterAction)
      })
      .catch((err) => {
        this.$store.commit('setLoadingSpinner', false);
        console.log(err);
      })
    },
    exifFile(file, rawImage, length, index, afterAction) {
      try {
        const orientation = EXIF.getTag(file, "Orientation");
        const canvas = document.createElement('canvas');

        if(orientation < 5 || orientation ===undefined) {
          canvas.width = rawImage.width;
          canvas.height = rawImage.height;
        }
        else {
          canvas.width = rawImage.height;
          canvas.height = rawImage.width;
        }

        document.body.appendChild(canvas);

        const ctx = canvas.getContext('2d');

        // 파일 사본일경우 exif가 없어서 orientation이 undefined이다
        // orientation 없을 경우
        if(orientation !== undefined) {

          if (orientation < 5)
            ctx.translate(rawImage.width * 0.5, rawImage.height * 0.5);
          else if(orientation === 6)
            ctx.translate(rawImage.height , 0);
          else
            ctx.translate(0, rawImage.width);

          switch (orientation) {
            case 2:
              // horizontal flip
              ctx.scale(-1, 1);
              break
            case 3:
              // 180° rotate left
              ctx.rotate(Math.PI);
              break
            case 4:
              // vertical flip
              ctx.scale(1, -1);
              break
            case 5:
              // vertical flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.scale(1, -1);
              break
            case 6:
              // 90° rotate right
              ctx.rotate(0.5 * Math.PI);
              break
            case 7:
              // horizontal flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.scale(-1, 1);
              break
            case 8:
              // 90° rotate left
              ctx.rotate(-0.5 * Math.PI);
              break
          }
          if (orientation < 5)
            ctx.translate(-rawImage.width * 0.5, -rawImage.height * 0.5);
        }

        ctx.drawImage(rawImage, 0, 0);

        const resizeImg = this.resizeImage(canvas);
        //canvas.remove();
        canvas.parentNode.removeChild(canvas);

        // Complete: After Action
        afterAction(file, resizeImg, length, index);

      } catch (err) {
        this.$store.commit('setLoadingSpinner', false);
        return console.log(err);
      }
    },
    resizeImage(image){
      let maxWidth = 1920;
      let maxHeight = 1920;
      let quality = 1.0;

      const scale = this.getNewScale(image, maxWidth, image.height);
      const scaledWidth = image.width / scale;
      // const scaledHeight = image.height / scale;
      const scaledHeight = image.height;

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = scaledWidth;
      canvas.height = scaledHeight;
      context.drawImage(image, 0, 0, scaledWidth, scaledHeight);
      // console.log(image)
      return canvas.toDataURL('image/png', quality)
    },
    getNewScale(image, maxWidth, maxHeight){
      if (image.width <= maxWidth && image.height <= maxHeight) {
        return 1
      }
      const isLandscape = image.width > image.height;
      const dimension = isLandscape ? image.width : image.height;
      return dimension / (isLandscape ? maxWidth : maxHeight)
    },
  }
}
